<div class="mt-1 mb-2">
    <div *ngIf="data.text" class="text-center">
        {{ data.text }}
    </div>
</div>
<div class="pull-right">
    <button (click)="onCancelClick()" mat-stroked-button>Ok</button>&nbsp;
</div>
